import { parseISO, eachHourOfInterval, endOfYear, format, eachMonthOfInterval, eachDayOfInterval, endOfMonth, endOfDay, endOfHour, eachYearOfInterval, eachWeekOfInterval, endOfWeek } from 'date-fns'
import intlFormatDistance from 'date-fns/intlFormatDistance'
export const settingBucket = (input) => {
  const startingDate = parseISO(input.timeFrame.previous)
  const endingDate = parseISO(input.timeFrame.today)
  const interval = { start: startingDate, end: endingDate }
  const durationTime = intlFormatDistance(endingDate, startingDate, { unit: 'day', numeric: 'always' })
  const durationArr = durationTime.split(' ')
  const duration = durationArr[1]

  let bucket = null
  if (duration > 912) {
    const test = eachYearOfInterval(interval)
    bucket = seeding(test, 'yyyy', 'year')
  } else if (duration >= 210) {
    const test = eachMonthOfInterval(interval)
    bucket = seeding(test, 'yy MMM', 'month')
  } else if (duration > 31) {
    const weeks = eachWeekOfInterval(interval)
    bucket = seeding(weeks, 'yy wo', 'week')
  } else if (duration > 1) {
    const test = eachDayOfInterval(interval)
    bucket = seeding(test, 'MMM dd', 'day')
  } else {
    const test = eachHourOfInterval(interval)
    bucket = seeding(test, 'MMM dd H:mm', 'hour')
  }

  return bucket
}

export const seeding = (interval, formatString, subtraction) => {
  switch (subtraction) {
    case 'hour':
      return interval.map((element) => {
        const label = format(element, formatString)
        const startingInterval = element.toISOString()
        const endingInterval = endOfHour(element).toISOString()
        return { sob: startingInterval, eob: endingInterval, xLabel: label, hits: 0 }
      })
    case 'day':
      return interval.map((element) => {
        const label = format(element, formatString)
        const startingInterval = element.toISOString()
        const endingInterval = endOfDay(element).toISOString()
        return { sob: startingInterval, eob: endingInterval, xLabel: label, hits: 0 }
      })
    case 'week':
      return interval.map((element) => {
        const label = format(element, formatString)
        const startingInterval = element.toISOString()
        const endingInterval = endOfWeek(element).toISOString()
        return { sob: startingInterval, eob: endingInterval, xLabel: label, hits: 0 }
      })
    case 'month':
      return interval.map((element) => {
        const label = format(element, formatString)
        const startingInterval = element.toISOString()
        const endingInterval = endOfMonth(element).toISOString()
        return { sob: startingInterval, eob: endingInterval, xLabel: label, hits: 0 }
      })
    case 'year':
      return interval.map((element) => {
        const label = format(element, formatString)
        const startingInterval = element.toISOString()
        const endingInterval = endOfYear(element).toISOString()
        return { sob: startingInterval, eob: endingInterval, xLabel: label, hits: 0 }
      })
    default:
      return {}
  }
}
